<template>
    <v-tabs
        centered
        color="black"
        slider-color="#99CC00"
    >
        <v-tab
            v-for="group in groupByOptions"
            :key="group.value"
            @click="$emit('change', group.value)"
            class="tab-text"
        >
            {{ group.name }}
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    name: "GroupByStudentsSelector",
    data(vm) {
        return {
            groupByOptions: [
                {name: vm.$tc('student.student', 2), value: 'students'},
                {name: `${vm.$t('common.group')}s`, value: 'groups'},
                {name: `${vm.$t('common.team')}s`, value: 'teams'},
            ],
        }
    }
}
</script>

<style scoped>

.tab-text {
    color: #333333 !important;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-transform: none;
    align-items: end;
    margin-bottom: 4px;
}

</style>